import {BookOpen, MessageCircleDashed as MessageCircle, Users, TrendingUp, Award} from 'lucide-react'
import { motion } from "framer-motion"

const differentials = [
  {
    icon: BookOpen,
    title: "É estruturado",
    description: "Você sabe exatamente o que estudar",
    border: "border-blue-600",
    iconColor: "text-blue-600",
  },
  {
    icon: MessageCircle,
    title: "É prático",
    description: "Você fala desde a primeira semana",
    border: "border-red-600",
    iconColor: "text-red-600",
  },
  {
    icon: Users,
    title: "É acompanhado por professores reais",
    description: "Não é você sozinho contra a plataforma",
    border: "border-blue-600",
    iconColor: "text-blue-600",
  },
  {
    icon: TrendingUp,
    title: "É progressivo",
    description: "Cada aula constrói a próxima",
    border: "border-red-600",
    iconColor: "text-red-600",
  },
  {
    icon: Award,
    title: "É validado",
    description: "Por mais de 10.000 alunos",
    border: "border-blue-600",
    iconColor: "text-blue-600",
  },
]

function WhyItWorks() {
  return (
    <section className="bg-white py-14 sm:py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10"
        >
          O método EW é diferente porque:
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {differentials.map((d, i) => (
            <motion.div
              key={d.title}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className={`bg-white rounded-2xl p-6 shadow-md border-t-4 ${d.border} hover:shadow-lg transition-shadow`}
            >
              <d.icon className={`w-10 h-10 ${d.iconColor} mb-4`} />
              <h3 className="font-bold text-gray-900 text-lg mb-2">{d.title}</h3>
              <p className="text-gray-600">{d.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center space-y-1"
        >
          <p className="text-gray-700 text-lg">Você não fica perdido.</p>
          <p className="text-gray-700 text-lg">Você não fica pulando conteúdo.</p>
          <p className="text-gray-900 font-bold text-xl">Você segue um caminho claro.</p>
          <p className="text-blue-600 font-extrabold text-2xl mt-2">E isso muda tudo.</p>
        </motion.div>
      </div>
    </section>
  )
}

export default WhyItWorks
